// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3sCag","footer":"ChangeClinic_footer__enkfM"};